export const convertToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    //@ts-ignore
    reader.onload = () => resolve(reader.result?.split("base64,")[1]);
    reader.onerror = (error) => reject(error);
  });
